import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  toString30pk9tzaqopn as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Enum3alwj03lh1n41 as Enum,
  emptyMapr06gerzljqtm as emptyMap,
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForInterface(ILogger, 'ILogger');
initMetadataForCompanion(Companion);
initMetadataForClass(Breadcrumb, 'Breadcrumb');
initMetadataForClass(BreadcrumbCategory, 'BreadcrumbCategory', VOID, Enum);
initMetadataForClass(Subsystem, 'Subsystem', VOID, Enum);
initMetadataForClass(ProcessingPhase, 'ProcessingPhase', VOID, Enum);
initMetadataForClass(Impact, 'Impact', VOID, Enum);
initMetadataForClass(InfrastructureIssue, 'InfrastructureIssue');
initMetadataForInterface(ILoggingProvider, 'ILoggingProvider');
//endregion
function ILogger() {
}
function reportInfrastructureIssueAndThrow(_this__u8e3s4, issue, throwable) {
  _this__u8e3s4.j6e(issue.q6e(VOID, VOID, VOID, VOID, VOID, throwable));
  throw throwable;
}
function get_loggingModule() {
  _init_properties_LoggingModule_kt__2ixq61();
  return loggingModule;
}
var loggingModule;
function loggingModule$lambda($this$module) {
  _init_properties_LoggingModule_kt__2ixq61();
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = loggingModule$lambda$lambda;
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Singleton_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(ILogger), null, definition, kind, secondaryTypes);
  var factory = new SingleInstanceFactory(def);
  $this$module.p1c(factory);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory);
  }
  new KoinDefinition($this$module, factory);
  return Unit_instance;
}
function loggingModule$lambda$lambda($this$single, it) {
  _init_properties_LoggingModule_kt__2ixq61();
  // Inline function 'org.koin.core.scope.Scope.get' call
  return $this$single.q1d(getKClass(ILoggingProvider), null, null).r6e();
}
var properties_initialized_LoggingModule_kt_dla7ut;
function _init_properties_LoggingModule_kt__2ixq61() {
  if (!properties_initialized_LoggingModule_kt_dla7ut) {
    properties_initialized_LoggingModule_kt_dla7ut = true;
    loggingModule = module_0(VOID, loggingModule$lambda);
  }
}
function Companion() {
}
protoOf(Companion).s6e = function (message) {
  return new Breadcrumb(message, true, null);
};
protoOf(Companion).t6e = function (message, category) {
  return new Breadcrumb(message, false, category);
};
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
function Breadcrumb(message, isExternalSafe, category) {
  this.u6e_1 = message;
  this.v6e_1 = isExternalSafe;
  this.w6e_1 = category;
}
protoOf(Breadcrumb).toString = function () {
  return 'Breadcrumb(message=' + this.u6e_1 + ', isExternalSafe=' + this.v6e_1 + ', category=' + toString(this.w6e_1) + ')';
};
protoOf(Breadcrumb).hashCode = function () {
  var result = getStringHashCode(this.u6e_1);
  result = imul(result, 31) + getBooleanHashCode(this.v6e_1) | 0;
  result = imul(result, 31) + (this.w6e_1 == null ? 0 : this.w6e_1.hashCode()) | 0;
  return result;
};
protoOf(Breadcrumb).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Breadcrumb))
    return false;
  var tmp0_other_with_cast = other instanceof Breadcrumb ? other : THROW_CCE();
  if (!(this.u6e_1 === tmp0_other_with_cast.u6e_1))
    return false;
  if (!(this.v6e_1 === tmp0_other_with_cast.v6e_1))
    return false;
  if (!equals(this.w6e_1, tmp0_other_with_cast.w6e_1))
    return false;
  return true;
};
var BreadcrumbCategory_CURL_instance;
var BreadcrumbCategory_RESPONSE_instance;
var BreadcrumbCategory_entriesInitialized;
function BreadcrumbCategory_initEntries() {
  if (BreadcrumbCategory_entriesInitialized)
    return Unit_instance;
  BreadcrumbCategory_entriesInitialized = true;
  BreadcrumbCategory_CURL_instance = new BreadcrumbCategory('CURL', 0, 'curl');
  BreadcrumbCategory_RESPONSE_instance = new BreadcrumbCategory('RESPONSE', 1, 'response');
}
function BreadcrumbCategory(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.z6e_1 = value;
}
function BreadcrumbCategory_CURL_getInstance() {
  BreadcrumbCategory_initEntries();
  return BreadcrumbCategory_CURL_instance;
}
function BreadcrumbCategory_RESPONSE_getInstance() {
  BreadcrumbCategory_initEntries();
  return BreadcrumbCategory_RESPONSE_instance;
}
var Subsystem_REST_instance;
var Subsystem_WEBSOCKET_instance;
var Subsystem_PREFERENCE_STORE_instance;
var Subsystem_entriesInitialized;
function Subsystem_initEntries() {
  if (Subsystem_entriesInitialized)
    return Unit_instance;
  Subsystem_entriesInitialized = true;
  Subsystem_REST_instance = new Subsystem('REST', 0);
  Subsystem_WEBSOCKET_instance = new Subsystem('WEBSOCKET', 1);
  Subsystem_PREFERENCE_STORE_instance = new Subsystem('PREFERENCE_STORE', 2);
}
var ProcessingPhase_MAPPING_instance;
var ProcessingPhase_INITIALIZATION_instance;
var ProcessingPhase_entriesInitialized;
function ProcessingPhase_initEntries() {
  if (ProcessingPhase_entriesInitialized)
    return Unit_instance;
  ProcessingPhase_entriesInitialized = true;
  ProcessingPhase_MAPPING_instance = new ProcessingPhase('MAPPING', 0);
  ProcessingPhase_INITIALIZATION_instance = new ProcessingPhase('INITIALIZATION', 1);
}
var Impact_LOW_instance;
var Impact_MEDIUM_instance;
var Impact_HIGH_instance;
var Impact_CRITICAL_instance;
var Impact_entriesInitialized;
function Impact_initEntries() {
  if (Impact_entriesInitialized)
    return Unit_instance;
  Impact_entriesInitialized = true;
  Impact_LOW_instance = new Impact('LOW', 0);
  Impact_MEDIUM_instance = new Impact('MEDIUM', 1);
  Impact_HIGH_instance = new Impact('HIGH', 2);
  Impact_CRITICAL_instance = new Impact('CRITICAL', 3);
}
function Subsystem(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ProcessingPhase(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Impact(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Subsystem_REST_getInstance() {
  Subsystem_initEntries();
  return Subsystem_REST_instance;
}
function Subsystem_WEBSOCKET_getInstance() {
  Subsystem_initEntries();
  return Subsystem_WEBSOCKET_instance;
}
function ProcessingPhase_MAPPING_getInstance() {
  ProcessingPhase_initEntries();
  return ProcessingPhase_MAPPING_instance;
}
function Impact_LOW_getInstance() {
  Impact_initEntries();
  return Impact_LOW_instance;
}
function Impact_MEDIUM_getInstance() {
  Impact_initEntries();
  return Impact_MEDIUM_instance;
}
function Impact_HIGH_getInstance() {
  Impact_initEntries();
  return Impact_HIGH_instance;
}
function InfrastructureIssue(subsystem, phase, impact, subject, metadata, throwable) {
  phase = phase === VOID ? null : phase;
  metadata = metadata === VOID ? emptyMap() : metadata;
  throwable = throwable === VOID ? null : throwable;
  this.k6e_1 = subsystem;
  this.l6e_1 = phase;
  this.m6e_1 = impact;
  this.n6e_1 = subject;
  this.o6e_1 = metadata;
  this.p6e_1 = throwable;
}
protoOf(InfrastructureIssue).a6f = function (subsystem, phase, impact, subject, metadata, throwable) {
  return new InfrastructureIssue(subsystem, phase, impact, subject, metadata, throwable);
};
protoOf(InfrastructureIssue).q6e = function (subsystem, phase, impact, subject, metadata, throwable, $super) {
  subsystem = subsystem === VOID ? this.k6e_1 : subsystem;
  phase = phase === VOID ? this.l6e_1 : phase;
  impact = impact === VOID ? this.m6e_1 : impact;
  subject = subject === VOID ? this.n6e_1 : subject;
  metadata = metadata === VOID ? this.o6e_1 : metadata;
  throwable = throwable === VOID ? this.p6e_1 : throwable;
  return $super === VOID ? this.a6f(subsystem, phase, impact, subject, metadata, throwable) : $super.a6f.call(this, subsystem, phase, impact, subject, metadata, throwable);
};
protoOf(InfrastructureIssue).toString = function () {
  return 'InfrastructureIssue(subsystem=' + this.k6e_1.toString() + ', phase=' + toString(this.l6e_1) + ', impact=' + this.m6e_1.toString() + ', subject=' + this.n6e_1 + ', metadata=' + toString_0(this.o6e_1) + ', throwable=' + toString(this.p6e_1) + ')';
};
protoOf(InfrastructureIssue).hashCode = function () {
  var result = this.k6e_1.hashCode();
  result = imul(result, 31) + (this.l6e_1 == null ? 0 : this.l6e_1.hashCode()) | 0;
  result = imul(result, 31) + this.m6e_1.hashCode() | 0;
  result = imul(result, 31) + getStringHashCode(this.n6e_1) | 0;
  result = imul(result, 31) + hashCode(this.o6e_1) | 0;
  result = imul(result, 31) + (this.p6e_1 == null ? 0 : hashCode(this.p6e_1)) | 0;
  return result;
};
protoOf(InfrastructureIssue).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof InfrastructureIssue))
    return false;
  var tmp0_other_with_cast = other instanceof InfrastructureIssue ? other : THROW_CCE();
  if (!this.k6e_1.equals(tmp0_other_with_cast.k6e_1))
    return false;
  if (!equals(this.l6e_1, tmp0_other_with_cast.l6e_1))
    return false;
  if (!this.m6e_1.equals(tmp0_other_with_cast.m6e_1))
    return false;
  if (!(this.n6e_1 === tmp0_other_with_cast.n6e_1))
    return false;
  if (!equals(this.o6e_1, tmp0_other_with_cast.o6e_1))
    return false;
  if (!equals(this.p6e_1, tmp0_other_with_cast.p6e_1))
    return false;
  return true;
};
function ILoggingProvider() {
}
//region block: init
Companion_instance = new Companion();
//endregion
//region block: exports
export {
  get_loggingModule as get_loggingModulez39rttqhqwlz,
  InfrastructureIssue as InfrastructureIssue2tvwph0eyadg1,
  ILoggingProvider as ILoggingProvider3qgs59b4tde8f,
  ILogger as ILogger102gekz4uf4a8,
  reportInfrastructureIssueAndThrow as reportInfrastructureIssueAndThrow19mdgs7yfj5lz,
  BreadcrumbCategory_CURL_getInstance as BreadcrumbCategory_CURL_getInstance2710rz708mc5v,
  BreadcrumbCategory_RESPONSE_getInstance as BreadcrumbCategory_RESPONSE_getInstance2la5p5q0jyryh,
  Impact_HIGH_getInstance as Impact_HIGH_getInstancexaobkfkrtcpy,
  Impact_LOW_getInstance as Impact_LOW_getInstance175qycs8r6wbm,
  Impact_MEDIUM_getInstance as Impact_MEDIUM_getInstance1z2bb1nzb3ufh,
  ProcessingPhase_MAPPING_getInstance as ProcessingPhase_MAPPING_getInstance16v9dkpvbjhjf,
  Subsystem_REST_getInstance as Subsystem_REST_getInstance2giohqo6b8l7w,
  Subsystem_WEBSOCKET_getInstance as Subsystem_WEBSOCKET_getInstance35tdr2j5vnyqn,
  Companion_instance as Companion_instancebove5hxj27a1,
};
//endregion

